var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_40",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5391 19.5474H24.5112V28.7747H37.7431C37.5304 30.0805 37.0528 31.3652 36.3534 32.5366C35.552 33.8786 34.5613 34.9004 33.5459 35.6785C30.5042 38.0093 26.958 38.4859 24.4952 38.4859C18.2738 38.4859 12.9581 34.4649 10.9002 29.0011C10.8172 28.8029 10.762 28.5981 10.6949 28.3956C10.2401 27.005 9.99169 25.5323 9.99169 24.0015C9.99169 22.4084 10.2607 20.8835 10.7513 19.4432C12.6864 13.7628 18.122 9.52012 24.4997 9.52012C25.7824 9.52012 27.0178 9.67282 28.1892 9.97738C30.8665 10.6734 32.7603 12.0442 33.9207 13.1286L40.9225 6.27151C36.6634 2.36633 31.1111 5.90435e-09 24.488 5.90435e-09C19.1933 -0.000113959 14.305 1.64956 10.2992 4.43757C7.05062 6.69857 4.38633 9.72576 2.58825 13.2415C0.915782 16.5013 0 20.1138 0 23.9979C0 27.8822 0.917181 31.5322 2.58966 34.7619V34.7837C4.3562 38.2124 6.93949 41.1646 10.0792 43.4152C12.8221 45.3814 17.7403 48 24.488 48C28.3684 48 31.8075 47.3004 34.8405 45.9893C37.0285 45.0435 38.9671 43.8098 40.7222 42.2244C43.0413 40.1294 44.8575 37.5382 46.0972 34.557C47.3369 31.5757 48 28.2044 48 24.5493C48 22.8471 47.829 21.1184 47.5391 19.5473V19.5474Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_40)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.2771 24.1023C-0.251646 27.9253 0.8377 31.8696 2.48661 35.0538V35.0757C3.67802 37.3881 5.30634 39.2148 7.16097 41.0246L18.3625 36.9374C16.2432 35.8609 15.9198 35.2013 14.4007 33.9976C12.8482 32.4322 11.6912 30.6351 10.9706 28.5278H10.9416L10.9706 28.5059C10.4966 27.1144 10.4498 25.6373 10.4323 24.1023H-0.2771Z",
    fill: "url(#paint0_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5875 -0.233215C23.4803 3.65637 23.9037 7.43718 24.5875 9.63702C25.866 9.63797 27.0976 9.79037 28.2654 10.094C30.9427 10.79 32.8363 12.1609 33.9967 13.2452L41.1778 6.21297C36.9237 2.31245 31.8041 -0.22707 24.5875 -0.233215Z",
    fill: "url(#paint1_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5635 -0.263977C19.1328 -0.264094 14.1191 1.42793 10.0104 4.28752C8.48491 5.34929 7.08495 6.57581 5.83838 7.93972C5.51181 11.0034 8.28302 14.7691 13.7709 14.7379C16.4335 11.6406 20.3716 9.63667 24.7546 9.63667C24.7586 9.63667 24.7625 9.637 24.7665 9.63701L24.5875 -0.263276C24.5794 -0.263281 24.5716 -0.263977 24.5635 -0.263977Z",
    fill: "url(#paint2_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4876 25.2109L37.6404 28.5408C37.4277 29.8467 36.9498 31.1313 36.2503 32.3027C35.449 33.6448 34.4584 34.6666 33.4429 35.4447C30.4075 37.7707 26.8707 38.2496 24.4085 38.2515C21.8636 42.586 21.4175 44.757 24.5875 48.2552C28.5101 48.2523 31.9877 47.5443 35.0551 46.2183C37.2724 45.2598 39.2369 44.0096 41.0156 42.4028C43.3658 40.2798 45.2067 37.6537 46.463 34.6325C47.7193 31.6112 48.3911 28.1948 48.3911 24.4908L42.4876 25.2109Z",
    fill: "url(#paint3_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2295 19.1382V29.0666H47.5506C47.7557 27.7069 48.434 25.9474 48.434 24.4908C48.434 22.7885 48.2632 20.7094 47.9733 19.1382H24.2295Z",
    fill: "#3086FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94966 7.5892C4.51051 9.16383 3.28103 10.9263 2.3062 12.8324C0.633758 16.0922 -0.281982 20.0552 -0.281982 23.9393C-0.281982 23.9941 -0.277452 24.0476 -0.277087 24.1022C0.463586 25.5224 9.95397 25.2504 10.4323 24.1022C10.4317 24.0487 10.4257 23.9964 10.4257 23.9427C10.4257 22.3497 10.6948 21.1754 11.1854 19.7352C11.7906 17.9586 12.7382 16.3227 13.9499 14.9131C14.2246 14.5625 14.9573 13.8086 15.171 13.3564C15.2524 13.1841 15.0232 13.0875 15.0104 13.0268C14.996 12.959 14.6887 13.0135 14.6198 12.963C14.4011 12.8027 13.9682 12.7189 13.7053 12.6445C13.1433 12.4854 12.212 12.1345 11.6947 11.7707C10.0596 10.621 7.50794 9.24759 5.94966 7.5892Z",
    fill: "url(#paint4_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7299 13.0336C15.5215 15.3304 16.6119 11.8743 19.1328 10.7928L14.7476 1.69913C13.1345 2.37712 11.6104 3.21946 10.1963 4.20365C8.08448 5.67348 6.21956 7.46709 4.67902 9.50825L11.7299 13.0336Z",
    fill: "url(#paint5_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2731 36.2349C8.1833 38.0724 7.38648 38.1383 6.91797 41.2925C7.81327 42.1662 8.7752 42.9744 9.79741 43.7071C12.5403 45.6733 17.8164 48.2919 24.5641 48.2919C24.572 48.2919 24.5796 48.2912 24.5875 48.2912V38.0763C24.5824 38.0763 24.5765 38.0766 24.5714 38.0766C22.0447 38.0766 20.0255 37.413 17.9553 36.2589C17.4448 35.9743 16.5188 36.7384 16.048 36.3968C15.3987 35.9257 13.8362 36.8027 13.2731 36.2349Z",
    fill: "url(#paint6_radial_17_40)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_17_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6067 37.7545V48.1142C22.5508 48.2248 23.5334 48.2919 24.5641 48.2919C25.5973 48.2919 26.597 48.2388 27.5683 48.1413V37.8244C26.4798 38.0105 25.4546 38.0766 24.5714 38.0766C23.5543 38.0766 22.5651 37.9582 21.6067 37.7545Z",
    fill: "url(#paint7_linear_17_40)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_17_40",
    x: -0.747179,
    y: 23.6322,
    width: 19.5797,
    height: 17.8625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_17_40",
    x: 23.4367,
    y: -0.703295,
    width: 18.2112,
    height: 14.4186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_17_40",
    x: 5.34242,
    y: -0.734056,
    width: 19.8941,
    height: 15.9422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_17_40",
    x: 21.8837,
    y: 24.0207,
    width: 26.9775,
    height: 24.7046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_17_40",
    x: 23.7594,
    y: 18.6682,
    width: 25.1447,
    height: 10.8685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_17_40",
    x: -0.752062,
    y: 7.11912,
    width: 16.4106,
    height: 18.419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_17_40",
    x: 1.37417,
    y: -1.60572,
    width: 21.0634,
    height: 18.7161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65243,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_17_40",
    x: 6.44789,
    y: 35.7239,
    width: 18.6097,
    height: 13.0381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_17_40",
    x: 21.1366,
    y: 37.2845,
    width: 6.90177,
    height: 11.4775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_17_40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.997443 -23.9038 35.8622 -1.43445 18.1382 40.6645)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.9393 -4.07113e-05 -2.38089e-05 21.4185 40.506 12.7364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-23.7332 12.8698 17.8375 31.532 31.2553 -3.36438)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.0409 -55.0094 -20.7393 15.555 24.9404 45.1486)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.04591 25.7043 36.3002 4.12336 22.4842 4.26946)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.80425 9.53355 -27.4644 -24.3132 18.2009 4.00284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_17_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-23.7332 -12.8698 17.8375 -31.532 31.2553 51.2464)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17_40",
    x1: 21.6067,
    y1: 43.0232,
    x2: 27.5683,
    y2: 43.0232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePositive);
export default __webpack_public_path__ + "static/media/google_positive.94619cc1cf117ae785ae9126d968e24a.svg";
export { ForwardRef as ReactComponent };